module.exports = __webpack_public_path__ + "static/media/ic_exit.63002100.svg";